var _defs, _g, _g2, _g3, _g4, _g5, _g6, _rect, _rect2, _rect3, _path, _rect4, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _path2, _g18, _path3, _path4, _g19, _g20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoto3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.205,
    height: 72.205,
    viewBox: "0 0 72.205 72.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#1b8379;}.c{fill:#939393;}.d{fill:#ffc89f;}.e{fill:#f7b081;}.f{fill:#f6dc74;}.g{fill:#fcd94e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.061 64.735)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "translate(0.041 0.367)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.061 60.05)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 3,
    transform: "translate(0.041 0.052)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.762 47.035)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "translate(0.341 0.067)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.526 47.035)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "translate(-0.423 0.067)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.84 47.035)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "translate(0.262 0.067)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.155 47.035)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "translate(-0.052 0.067)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 69,
    height: 57,
    transform: "translate(1.602 15.102)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 5,
    height: 12,
    transform: "translate(9.102 6.102)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 5,
    height: 12,
    transform: "translate(57.102 6.102)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71,7.22a1.2,1.2,0,0,0,1.2-1.2V1.2A1.2,1.2,0,0,0,71,0H1.2A1.2,1.2,0,0,0,0,1.2V6.017a1.2,1.2,0,0,0,1.2,1.2h7.22v6.017H1.2a1.2,1.2,0,0,0-1.2,1.2V71a1.2,1.2,0,0,0,1.2,1.2H71A1.2,1.2,0,0,0,72.2,71V14.441a1.2,1.2,0,0,0-1.2-1.2h-7.22V7.22ZM25.412,69.8l.782-7.045a3.616,3.616,0,0,1,1.815-2.745l5.1-2.876c.058.025.118.042.176.066.155.063.31.124.469.177.1.035.208.063.313.093.15.043.3.087.454.119.119.026.239.043.36.063.143.024.284.052.43.067.168.018.337.023.505.029.1,0,.189.018.285.018s.19-.013.285-.017c.168-.006.337-.011.505-.029.144-.016.286-.043.43-.067.12-.02.241-.037.36-.063.154-.034.3-.077.454-.119.1-.03.209-.058.313-.093.159-.053.314-.114.469-.177.058-.024.118-.041.176-.066l5.1,2.876a3.618,3.618,0,0,1,1.815,2.745l.782,7.044Zm7.655-21.807a7.184,7.184,0,0,0,2.172-1.828,22.54,22.54,0,0,0,4.075,1.9,21.8,21.8,0,0,0,2.776.752,7.281,7.281,0,0,1-3.513,5.889l-.017.006a5.07,5.07,0,0,1-4.918,0l-.017-.006a7.28,7.28,0,0,1-3.513-5.9A6.956,6.956,0,0,0,33.067,47.991Zm-2.794-1.6a7.747,7.747,0,0,1,1.394-3.118l0,0a6.113,6.113,0,0,1,2.382-1.915c.032-.014.065-.03.1-.043a5.164,5.164,0,0,1,.875-.276c.046-.01.094-.017.14-.025a4.957,4.957,0,0,1,.939-.1,5.137,5.137,0,0,1,.916.093c.063.012.126.02.189.035a5.259,5.259,0,0,1,.789.244c.087.035.171.073.255.112a5.623,5.623,0,0,1,.605.324c.114.071.226.149.337.229q.224.161.434.345c.1.083.193.165.284.255a6.712,6.712,0,0,1,.5.556c.081.1.156.2.232.306a7.329,7.329,0,0,1,.449.692c.039.067.07.14.106.209a7.858,7.858,0,0,1,.361.8c.017.043.035.084.052.128a8.177,8.177,0,0,1,.306,1.065.265.265,0,0,1,.006.03c-.616-.152-1.215-.33-1.811-.539a20.231,20.231,0,0,1-4.543-2.272,1.2,1.2,0,0,0-1.717.408,4.974,4.974,0,0,1-1.934,1.94A4.492,4.492,0,0,1,30.273,46.393ZM69.8,15.644V69.8H49.213l-.812-7.31a6.031,6.031,0,0,0-3.024-4.577L41.36,55.647a10.171,10.171,0,0,0,3.166-7.51c0-.108-.011-.212-.014-.319,0,0,0,0,0-.006,0-.018,0-.036,0-.054q-.014-.442-.063-.875c0-.041-.011-.082-.017-.123-.032-.262-.072-.521-.124-.775-.018-.091-.041-.179-.061-.27-.045-.2-.09-.391-.144-.581-.047-.165-.1-.325-.155-.485-.037-.11-.072-.221-.113-.33-.091-.245-.195-.484-.3-.718l-.028-.061a8.294,8.294,0,0,0-7.4-5.03,7.456,7.456,0,0,0-.839.048c-.122.014-.241.041-.361.06-.15.025-.3.045-.45.078s-.3.083-.448.126c-.112.032-.225.06-.335.1-.165.057-.324.126-.485.194-.088.037-.178.07-.265.111-.168.079-.332.17-.495.26-.073.041-.148.078-.22.122-.167.1-.329.212-.49.324-.063.043-.126.084-.188.13-.161.12-.316.249-.471.381-.055.047-.112.093-.166.142-.153.138-.3.285-.444.436-.048.051-.1.1-.146.152-.143.155-.279.319-.413.485-.043.054-.087.107-.129.161-.131.172-.255.35-.377.532-.037.057-.075.111-.11.168-.119.189-.232.384-.339.582-.03.055-.059.11-.088.165-.107.206-.206.418-.3.633-.023.053-.046.106-.067.16q-.137.336-.253.684c-.017.049-.032.1-.048.148q-.114.361-.2.735l-.029.129q-.087.388-.147.789l-.014.107q-.056.413-.082.835l0,.036s0,.007,0,.011c-.01.2-.025.4-.025.6a10.168,10.168,0,0,0,3.167,7.51l-4.017,2.265A6.031,6.031,0,0,0,23.8,62.488l-.814,7.31H2.407V15.644H8.424v2.407a1.2,1.2,0,0,0,1.2,1.2h4.814a1.2,1.2,0,0,0,1.2-1.2V15.644H56.56v2.407a1.2,1.2,0,0,0,1.2,1.2h4.814a1.2,1.2,0,0,0,1.2-1.2V15.644Zm-58.967,1.2V7.22h2.407v9.627Zm4.814-3.61V7.22H56.56v6.017Zm43.323,3.61V7.22h2.407v9.627Zm3.61-12.034H2.407V2.407H69.8V4.814Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 34,
    transform: "translate(18.102 36.102)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.551 -40.429)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.081,260.474H32.67v-4.042c0-6.644-5.947-12.082-12.59-12.173-6.643.091-12.59,5.529-12.59,12.173v4.042Z",
    transform: "translate(-6.53 -148.904)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M96.892,244.259a12.457,12.457,0,0,0-1.282.084c6.107.717,11.308,5.875,11.308,12.088v4.042h2.563v-4.042C109.481,249.788,103.535,244.35,96.892,244.259Z",
    transform: "translate(-83.341 -148.904)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M64.729,127.431h0a6.034,6.034,0,0,1-6.017-6.017v-5.178a6.034,6.034,0,0,1,6.017-6.017h0a6.034,6.034,0,0,1,6.017,6.017v5.178A6.034,6.034,0,0,1,64.729,127.431Z",
    transform: "translate(-51.178 -32.065)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M96.892,110.221h0a5.982,5.982,0,0,0-1.282.14,6.039,6.039,0,0,1,4.735,5.877v5.178a6.039,6.039,0,0,1-4.735,5.877,5.982,5.982,0,0,0,1.282.14h0a6.034,6.034,0,0,0,6.017-6.017v-5.178A6.034,6.034,0,0,0,96.892,110.221Z",
    transform: "translate(-83.341 -32.066)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M84.4,282.159,87.52,279.3l-1.676-7.274h-2.89L81.278,279.3Z",
    transform: "translate(-70.848 -173.11)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.49 95.355)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M100.513,272.029H98.591l1.676,7.274-2.16,1.977.961.88,3.121-2.856Z",
    transform: "translate(-96.007 -268.465)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M83.359,247.823h2.89l1.616-3.14a11.273,11.273,0,0,0-6.123,0Z",
    transform: "translate(-81.743 -244.259)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.565,120.587a6.973,6.973,0,0,0,2.963-5.7v-5.178a6.978,6.978,0,1,0-13.956,0v5.178a6.973,6.973,0,0,0,2.963,5.7A13.476,13.476,0,0,0,0,133.064v4.042a.961.961,0,0,0,.961.961H5.932a.961.961,0,1,0,0-1.923H1.922v-3.081a10.8,10.8,0,0,1,3.5-7.847A12.377,12.377,0,0,1,10,122.47l1.086,2.111-1.6,6.931a.962.962,0,0,0,.288.925l3.121,2.856a.961.961,0,0,0,1.3,0l3.121-2.856a.961.961,0,0,0,.288-.925l-1.6-6.931L17.1,122.47a12.377,12.377,0,0,1,4.576,2.746,10.8,10.8,0,0,1,3.5,7.847v3.081H9.136a.961.961,0,1,0,0,1.923h17a.961.961,0,0,0,.961-.961v-4.042A13.477,13.477,0,0,0,17.565,120.587Zm-9.07-5.7v-2.63a7.808,7.808,0,0,0,6.213-3.51,5.847,5.847,0,0,0,3.9,3.452v2.688a5.061,5.061,0,0,1-4.85,5.05l-.192-.005h-.026l-.192.005A5.061,5.061,0,0,1,8.5,114.884Zm5.055,18.4L11.492,131.4l1.378-5.982h1.36l1.378,5.982Zm.859-9.789H12.692l-.771-1.5q.251-.04.5-.069l.059-.006c.148-.016.3-.029.444-.04l.119-.008c.116-.007.232-.01.348-.014.053,0,.1,0,.158,0s.105,0,.158,0c.116,0,.232.007.348.014l.119.008c.148.011.3.023.444.04l.058.006q.252.029.5.069Z",
    transform: "translate(0 -25.536)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.076 47.035)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    transform: "translate(0.026 0.067)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.968 47.035)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2,
    transform: "translate(0.135 0.067)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.679 42.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    transform: "translate(0.423 -0.247)"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.364 42.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "translate(-0.262 -0.247)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.679 51.72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 2,
    transform: "translate(0.423 0.382)"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.364 51.72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "translate(-0.262 0.382)"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.443 42.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "translate(-0.341 -0.247)"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.237 42.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "translate(-0.135 -0.247)"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.237 51.72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "translate(-0.135 0.382)"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.443 51.72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "translate(-0.341 0.382)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M56.294,24.66l1.68,2.318,3.163.872-2.067,3.42.549,4.131-4.2-1.762L51.358,35.4V30.911l-1.976-3.062,3.478-.872,2.217-3.228Z",
    transform: "translate(-19.157 -3.685)"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.678 18.084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.8,125.881a1.2,1.2,0,0,0-.868-.846l-4.362-1.09-2.149-3.224a1.248,1.248,0,0,0-2,0l-2.149,3.224-4.362,1.09a1.2,1.2,0,0,0-.558,2.018l3.129,3.129-1.039,4.153a1.2,1.2,0,0,0,1.706,1.367l4.275-2.137L196.7,135.7a1.2,1.2,0,0,0,1.705-1.367l-1.039-4.153,3.129-3.129A1.2,1.2,0,0,0,200.8,125.881Zm-5.621,3.081a1.2,1.2,0,0,0-.316,1.142l.569,2.276-2.473-1.236a1.206,1.206,0,0,0-1.077,0l-2.473,1.236.569-2.276a1.2,1.2,0,0,0-.316-1.142l-2.107-2.107,2.752-.688a1.2,1.2,0,0,0,.709-.5l1.4-2.107,1.406,2.108a1.2,1.2,0,0,0,.709.5l2.752.688Z",
    transform: "translate(-183.998 -120.218)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M56.294,24.66l1.68,2.318,3.163.872-2.067,3.42.549,4.131-4.2-1.762L51.358,35.4V30.911l-1.976-3.062,3.478-.872,2.217-3.228Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M56.294,24.66l1.68,2.318,3.163.872-2.067,3.42.549,4.131-4.2-1.762L51.358,35.4V30.911l-1.976-3.062,3.478-.872,2.217-3.228Z",
    transform: "translate(-38.412 0)"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.933 21.694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.8,149.881a1.2,1.2,0,0,0-.868-.846l-4.362-1.09-2.149-3.224a1.248,1.248,0,0,0-2,0l-2.149,3.224-4.362,1.09a1.2,1.2,0,0,0-.558,2.018l3.129,3.129-1.039,4.153a1.2,1.2,0,0,0,1.706,1.367l4.275-2.137L324.7,159.7a1.2,1.2,0,0,0,1.705-1.367l-1.039-4.153,3.129-3.129A1.2,1.2,0,0,0,328.8,149.881Zm-5.621,3.081a1.2,1.2,0,0,0-.316,1.142l.569,2.276-2.473-1.236a1.206,1.206,0,0,0-1.077,0l-2.473,1.236.569-2.276a1.2,1.2,0,0,0-.316-1.142l-2.107-2.107,2.752-.688a1.2,1.2,0,0,0,.709-.5l1.4-2.107,1.406,2.108a1.2,1.2,0,0,0,.709.5l2.752.688Z",
    transform: "translate(-311.998 -144.218)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.424 21.694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.8,149.881a1.2,1.2,0,0,0-.868-.846l-4.362-1.09-2.149-3.224a1.248,1.248,0,0,0-2,0l-2.149,3.224-4.362,1.09a1.2,1.2,0,0,0-.558,2.018l3.129,3.129-1.039,4.153a1.2,1.2,0,0,0,1.706,1.367l4.275-2.137L68.7,159.7a1.2,1.2,0,0,0,1.705-1.367l-1.039-4.153,3.129-3.129A1.2,1.2,0,0,0,72.8,149.881Zm-5.621,3.081a1.2,1.2,0,0,0-.317,1.142l.569,2.276-2.473-1.236a1.206,1.206,0,0,0-1.077,0l-2.473,1.236.569-2.276a1.2,1.2,0,0,0-.316-1.142l-2.107-2.107,2.752-.688a1.2,1.2,0,0,0,.709-.5l1.4-2.107,1.406,2.108a1.2,1.2,0,0,0,.709.5l2.752.688Z",
    transform: "translate(-55.998 -144.218)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto3);
export default __webpack_public_path__ + "static/media/photo_3.4fdcf24ecf818a0b5a1b71b7f377f41a.svg";
export { ForwardRef as ReactComponent };